$(document).ready(function() {
    const $selectCity = $("#selectCity");
    const $selectOfferTypes = $("#selectOfferTypes");
    const $selectProperyTypes = $("#selectProperyTypes");
    const $searchButton = $("#searchButton");
    const $floorageFrom = $('#spaceFrom');
    const $floorageTo = $('#spaceTo');

    $searchButton.on('click', () => {
        $selectCity.change();
        $selectOfferTypes.change();
        $selectProperyTypes.change();
        let floorage = null;

        if ( $floorageFrom.val() && $floorageTo.val() ) {
            floorage = {filter_total_floorage: `><${$floorageFrom.val()},${$floorageTo.val()}`};
        } else if ( !$floorageFrom.val() && $floorageTo.val() ) {
            floorage = {filter_total_floorage: `><0,${$floorageTo.val()}`};
        } else if ( $floorageFrom.val() && !$floorageTo.val() ) {
            floorage = {filter_total_floorage: `><${$floorageFrom.val()}`}
        }

        const cityId = JSON.parse($selectCity.val());
        const formState = {
            filter_offer_type: $selectOfferTypes.val(),
            filter_property_types: $selectProperyTypes.val(),
            city_id: cityId.id,
            ...floorage
        };

        sessionStorage.clear();
        sessionStorage.setItem('State', JSON.stringify(formState));

        sessionStorage.setItem('HomepageForm', 'true');

        setTimeout(() => { window.location.href = '/properties/catalogue/'; }, 500);
    });

    /** Clears Local Storage **/
    localStorage.clear();
});
